<template>
  <div>
    <div class="xul">
      <span class="cz" v-if="userInfo.id==item.uid">这是您上传的资源，可直接下载</span>

      <span class="cz" v-else-if="isGm">您已购买，可直接下载</span>

      <!-- <span class="cz" v-else-if="item.money">
        该资源需消耗
        <span class="red">{{ item.money }}</span>
        知识币
        <span v-show="item.money * 1 > Money* 1">
          知识币,当前知识币不足,请先去充值知识币
        </span>
        当前知识币
        <span class="red">{{ Money }}</span>个
      </span> -->

      <span v-else>该资源为免费资源，可直接下载</span>

    </div>

    <div class="czfs">
      <el-button type="primary" size="mini" @click="pay" v-if="isZf()">确认支付</el-button>
      <el-button type="primary" size="mini" @click="indownload">下载</el-button>
    </div>
  </div>
</template>

<script>
import { getById,isBuy,changeNum,buyResource,getUserInfo  } from '@/services'
import api from '@/services/config.js'
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    userInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Money: "",
      isGm:false
    };
  },
  created() {
    this.getMoney();
  },
  methods: {

    //获取用户当前知识币
    getMoney() {
      if(this.userInfo.id==this.item.uid||this.item.money<=0){
        return
      }


      let getMoney = getById({ id: this.userInfo.id });
      let getIsGm = isBuy({ resourceId: this.item.id,uId:this.userInfo.id });
      Promise.all([getMoney,getIsGm]).then(([getMoney,getIsGm])=>{
        if(getMoney.success){
          this.Money = getMoney.data.money
        }
        if(getIsGm.success){
          this.isGm = getIsGm.data=='true'
        }
      })
    },

    //是否需要付费
    isZf(){
      if(this.userInfo.id==this.item.uid){
        return false
      }
      if(this.isGm){
        return false
      }
      if(this.item.money<=0){
        return false;
      }

      return true;
    },

    //直接下载
    indownload() {
      if(this.isZf()){
        this.$message({
          message:'请付费后下载',
          type:'warning'
        })
        return 
      }
      changeNum({resourceId:this.item.id,type:2});
      location.href = api.concat('/resource/downFile?path='+this.item.savePath);

      // 下载
      // downFile({ path: this.item.savePath }).then(res => {
      //   const blob = new Blob([res]); //构造一个blob对象来处理数据
      //   const fileName = this.item.name + '.' + this.item.type;
      //   const link = document.createElement("a"); //创建a标签
      //   link.download = fileName; //a标签添加属性
      //   link.style.display = "none";
      //   link.href = URL.createObjectURL(blob);
      //   link.click(); //执行下载
      //   // URL.revokeObjectURL(link.href); //释放url
      //   // document.body.removeChild(link); //释放标签
      //   // updatedownload(this.id, this.download);
      //   // this.$router.back(-1)
      //   // } else {
      //   //   //其他浏览器
      //   //   navigator.msSaveBlob(blob, fileName);
      //   // }
      // })
    },

    // /验证用户数据并获取用户信息    
    getUserInfo() {
      parseToken().then((res = {}) => {
        let { data, message, success } = res;
        if (success) {
          this.userInfo = data;
          sessionStorage.setItem('userInfo',JSON.stringify(data));
        } else {
          // this.userInfo = null;
        }
      }).catch(err=>{
        console.log(err);
      })
    },


    

      //付费下载
    async pay() {
      let token = localStorage.getItem('token');
      if(!token){
        this.$message({
          message:'请登录',
          type:'warning'
        })
      }
      if(this.item.money*1>this.Money*1){
        // this.$message.warning('当前知识币不足,请先去充值知识币')
        return
      }

      let data={
        money:this.item.money,  //金额
        rid:this.item.id,   //资源id
        uid:this.userInfo.id,   //购买用户id
        orderName:'购买资源',
        type:1,
      }

      buyResource(data).then(res=>{
        if(res.success){
          this.isGm = true;
          this.$confirm('购买成功，是否立即下载？')
          .then(()=> {
            this.indownload();
            this.getUserInfo();

          })
        }else{
          this.$message({
            message:'购买失败',
            type:'warning'
          })
        }
      })
    },
  },
};
</script>

<style scoped>
.xul {
  width: 100%;
  overflow: hidden;
  text-align: center;
}

.cz {
  margin-top: 55px;
  letter-spacing: 2px;
}

.red {
  color: red;
}

.money {
  float: left;
  /* width: 114px; */
  /* height: 114px; */
  background-color: #ffffff;
  /* line-height: 114px; */
  color: black;
  padding: 20px;
  margin-left: 10px;
}

.je {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
}

.jg {
  font-size: 48px;
  font-family: Microsoft YaHei;
  font-weight: 800;
  color: rgba(234, 74, 74, 1);
  line-height: 34px;
}

.czfs {
  width: 100%;
  overflow: hidden;
  margin-top: 30px;
  margin-left: 45%;
}

.czfs span {
  width: 163px;
  height: 54px;
  float: left;
  background-color: #ffffff;
  line-height: 64px;
  margin: 10px 30px 10px 30px;
}

.czfs span img {
  width: 22px;
  margin: 20px 10px 20px 20px;
  float: left;
}
</style>
